// extracted by css-extract-rspack-plugin
export default {"traceList":"TraceList-module__traceList__iiMvC","traceTable":"TraceList-module__traceTable__T0kow"};